// Third Party
import * as $ from "jquery"

// Mixins
import { tableMixins } from "@/app/mixins/utils/table-mixins"
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins"

// Constants
import { FREQUENCY_CODE, TRANSLATE_PERIOD } from "@/app/constants/subscription-constants"

export default {
	name: "ModalSuccessPayment",
	mixins: [tableMixins, toastMessageMixins],
	data() {
		return {
			isAPILoading: false,
			// table
			theads: [
				{ name: "Image", sortLabel: null, isDesc: false, style: null },
				{ name: "Products", sortLabel: null, isDesc: false, style: null },
				{ name: "Quantity", sortLabel: null, isDesc: false, style: null },
				{ name: "Price", sortLabel: null, isDesc: false, style: "width: 100px;" },
			],
			subHeads: [
				{ name: "Image", sortLabel: null, isDesc: false, style: null },
				{ name: "Products", sortLabel: null, isDesc: false, style: null },
				{ name: "Frequency", sortLabel: null, isDesc: false, style: null },
				{ name: "Period", sortLabel: null, isDesc: false, style: null },
				{ name: "Price", sortLabel: null, isDesc: false, style: "width: 100px;" },
			],
			modalContent: {},
			orderDetails: null,
			routeRedirection: "/products/cart",

			subtotal: 0,
			total: 0,

			isSubscription: false,

			// delivery
			deliveryMin: process.env.VUE_APP_DELIVERY_MIN,
			deliveryFee: process.env.VUE_APP_DELIVERY_FEE,
		}
	},
	computed: {
		getSelectedCartContent() {
			return this.$store.getters.getSelectedCartContent
		},
		isNativeApp() {
			return this.$store.getters.getIsNativeApp
		},
		getIfSubscription() {
			let flag = false

			if (this.getSelectedCartContent && this.getSelectedCartContent.length > 0) {
				flag = this.getSelectedCartContent[0].subscriptionBundle
			}

			return flag
		},
		
	},
	mounted() {
		$(this.$refs.modalOrderDetails).on("hide.bs.modal", this.handleHideEvent)
	},
	beforeDestroy() {
		this.hideModal()
		$(this.$refs.modalOrderDetails).off("hide.bs.modal", this.handleHideEvent)
	},
	methods: {
		openModal(data) {
			this.modalContent = data
			this.getTransactionDetails()
			$(this.$refs.modalOrderDetails).modal("show")
		},
		hideModal() {
			$(this.$refs.modalOrderDetails).modal("hide")
		},
		closeModal() {

			if (this.isNativeApp) {

				setTimeout(function () {
					window.ReactNativeWebView.postMessage("cart")
				}, 0)
			}
			this.hideModal()
		},
		handleHideEvent() {
			this.$store.commit("clearSelectedCartTableAndContent")
			this.$router.push(this.routeRedirection)
		},
		handleRedirection(route) {
			if (this.isNativeApp) {

				setTimeout(function () {
					window.ReactNativeWebView.postMessage(route)
				}, 0)
			}

			switch (route) {
				case "transactions":
					this.routeRedirection = "/purchases"
					break
				case "products":
					this.routeRedirection = "/products"
					break
				case "subscriptions":
					this.routeRedirection = "/purchases/subscriptions"
					break
				case "dashboard":
					this.routeRedirection = "/dashboard"
					break
				default:
					this.routeRedirection = "/products"
					break
			}

			this.hideModal()
		},
		getTransactionDetails() {
			const orders = JSON.parse(JSON.stringify(this.getSelectedCartContent))

			this.orderDetails = orders.map((order) => {
				let detail = {}

				if (order.subscriptionBundle) {
					detail = {
						id: order.bundleId,
						name: order.name,
						imageUrl: order.products[0].productImg,
						price: order.price,
						cartPaymentFrequency: FREQUENCY_CODE[order.cartPaymentFrequency],
						cartSubscriptionPeriod: TRANSLATE_PERIOD[order.cartSubscriptionPeriod],
					}
				} else {
					detail = {
						id: order.bundleId,
						name: order.name,
						imageUrl: order.isCustomBundle ? order.bundleImg : order.products[0].productImg,
						price: order.price,
						quantity: order.quantity,
					}
				}

				detail = {...detail, isSubscription: order.subscriptionBundle || false};

				return detail;
			})

			const totalProductsCost = [...this.orderDetails].reduce((sum, order) => sum + parseFloat(order.price), 0);
			this.subtotal = totalProductsCost;

			let newTotal = totalProductsCost;
			
			if(totalProductsCost <= parseFloat(this.deliveryMin)){
				newTotal = totalProductsCost + parseFloat(this.deliveryFee);
			}

			this.total = newTotal.toFixed(2);

			this.isSubscription = [...this.orderDetails].some(order => order.isSubscription);
		},
	},
}
